const _import = require('../router/_import_' + process.env.NODE_ENV) //获取组件的方法
import storage                              from 'good-storage';

export default {

    /**
     * 使用routers循环遍历匹配urls中的值，
     * @param {路由配置项} routers
     * @param {需要匹配的路由--默认每个路由path都为唯一的} urls
     */
    whileJudgeRouter(routers, urls) {
        // debugger;
        if (urls == null || urls == undefined || urls.length == 0) {
            return false;
        }
        let currentIsFlag = false;      // 判断当前层级下的多个节点是有显示的
        routers.map(r => {
            r.showFlag = false;
            if (r.children != undefined && r.children.length > 0) {
                let childrenIsFlag = this.whileJudgeRouter(r.children, urls);
                // if (childrenIsFlag) {
                //     r.showFlag = true;
                // }
                if ( childrenIsFlag || urls.indexOf(r.path) > -1) {
                    r.showFlag = true;
                } else {
                    r.showFlag = false;
                }
            } else if (r.path == undefined) {
                r.showFlag = false;
            } else {
                if (r.showFlag == false && urls.indexOf(r.path) == -1) {
                    r.showFlag = false;
                } else {
                    r.showFlag = true;
                }
                if (r.showFlag) {
                    currentIsFlag = true;
                }
            }
        });
        return currentIsFlag;
    },
    hideNotShow(n) {
        n = n.filter(i => {
            if (i.children) {
                i.children = this.hideNotShow(i.children);
                if (i.children && i.children.length > 0 && i.showFlag) {
                    return i;
                }
            }
            if (i.showFlag) {
                return i;
            }
        });
        return n;
    },


    saveObjArr(name, data) { //sessionStorage 存储数组对象的方法
        storage.session.set(name, data)
    },

    getObjArr(name) { //sessionStorage 获取数组对象的方法
        return storage.session.get(name);
    },

    filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
        const accessedRouters = asyncRouterMap.filter(route => {
            if (route.component) {
                if (route.component === 'Layout') { //Layout组件特殊处理
                    route.component = Layout
                } else {
                    route.component = _import(route.component)
                    // route.component = route.component
                }
            }
            if (route.children && route.children.length) {
                route.children = this.filterAsyncRouter(route.children)
            }
            return true
        })

        return accessedRouters
    },
    sortRouter(a, b) {
        var s = [];
        b.map(c => {
           var e = a.filter(d => {
               if (c.menuUrl == d.path) {
                   s.push(d);
                   return d;
               }
           });
        });
        if (s.length != a.length) {
            return a;
        }
        return s;
    }
}


// WEBPACK FOOTER //
// ./src/util/router-utils.js